export class UploadFileMasterDataMandatoryColumn {

    public column: number;
    public columnName: string;
    public row: number;

    static fromDto(data: any) {
      if (!data) {
        return null;
      }

      const column = new UploadFileMasterDataMandatoryColumn();

      column.column   = data.column;
      column.columnName   = data.columnName;
      column.row = data.row;

      return column;
    }
  }
